"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stencilNameFromString = exports.isStencilName = exports.supportedStencilNames = void 0;
exports.supportedStencilNames = [
    'apple-immersive-video',
    'artist',
    'athlete',
    'audio-clip',
    'author',
    'content-category',
    'content-collection',
    'content-hub',
    'collection',
    'country',
    'discipline',
    'editorial-list',
    'energy-drink',
    'episode-video',
    'event-details',
    'event-profile',
    'event-season',
    'event-series',
    'external-content-resource',
    'external-person',
    'external-team',
    'film',
    'geolocation',
    'image',
    'image-gallery',
    'immersive-3d-model',
    'judge',
    'live-video',
    'lsc',
    'misc',
    'occasion',
    'occasion-campaign',
    'onsite-promotion',
    'partner-profile',
    'photographer',
    'playground',
    'podcast-episode',
    'podcast-season',
    'podcast-show',
    'preview-clip',
    'project-profile',
    'rally-driver',
    'rally-team',
    'recap-video',
    'results-and-standings',
    'season',
    'show',
    'story',
    'team',
    'trailer-video',
    'tv-commercial',
    'tv-partner-channel',
    'video',
    'video-3d',
    'video-channel',
    'video-vr-360',
    'virtual-geolocation',
    'worldwide-geolocation',
];
const isStencilName = (value) => {
    const arr = [...exports.supportedStencilNames];
    return arr.includes(value);
};
exports.isStencilName = isStencilName;
const stencilNameFromString = (value) => {
    if ((0, exports.isStencilName)(value)) {
        return value;
    }
    throw Error(`'${value}' is not a valid stencil name`);
};
exports.stencilNameFromString = stencilNameFromString;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RlbmNpbC5tb2RlbC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9tb2RlbHMvc3RlbmNpbC5tb2RlbC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFLYSxRQUFBLHFCQUFxQixHQUFHO0lBQ25DLHVCQUF1QjtJQUN2QixRQUFRO0lBQ1IsU0FBUztJQUNULFlBQVk7SUFDWixRQUFRO0lBQ1Isa0JBQWtCO0lBQ2xCLG9CQUFvQjtJQUNwQixhQUFhO0lBQ2IsWUFBWTtJQUNaLFNBQVM7SUFDVCxZQUFZO0lBQ1osZ0JBQWdCO0lBQ2hCLGNBQWM7SUFDZCxlQUFlO0lBQ2YsZUFBZTtJQUNmLGVBQWU7SUFDZixjQUFjO0lBQ2QsY0FBYztJQUNkLDJCQUEyQjtJQUMzQixpQkFBaUI7SUFDakIsZUFBZTtJQUNmLE1BQU07SUFDTixhQUFhO0lBQ2IsT0FBTztJQUNQLGVBQWU7SUFDZixvQkFBb0I7SUFDcEIsT0FBTztJQUNQLFlBQVk7SUFDWixLQUFLO0lBQ0wsTUFBTTtJQUNOLFVBQVU7SUFDVixtQkFBbUI7SUFDbkIsa0JBQWtCO0lBQ2xCLGlCQUFpQjtJQUNqQixjQUFjO0lBQ2QsWUFBWTtJQUNaLGlCQUFpQjtJQUNqQixnQkFBZ0I7SUFDaEIsY0FBYztJQUNkLGNBQWM7SUFDZCxpQkFBaUI7SUFDakIsY0FBYztJQUNkLFlBQVk7SUFDWixhQUFhO0lBQ2IsdUJBQXVCO0lBQ3ZCLFFBQVE7SUFDUixNQUFNO0lBQ04sT0FBTztJQUNQLE1BQU07SUFDTixlQUFlO0lBQ2YsZUFBZTtJQUNmLG9CQUFvQjtJQUNwQixPQUFPO0lBQ1AsVUFBVTtJQUNWLGVBQWU7SUFDZixjQUFjO0lBQ2QscUJBQXFCO0lBQ3JCLHVCQUF1QjtDQUNmLENBQUE7QUFFSCxNQUFNLGFBQWEsR0FBRyxDQUFDLEtBQWEsRUFBd0IsRUFBRTtJQUNuRSxNQUFNLEdBQUcsR0FBRyxDQUFDLEdBQUcsNkJBQXFCLENBQWEsQ0FBQTtJQUVsRCxPQUFPLEdBQUcsQ0FBQyxRQUFRLENBQUMsS0FBSyxDQUFDLENBQUE7QUFDNUIsQ0FBQyxDQUFBO0FBSlksUUFBQSxhQUFhLGlCQUl6QjtBQUVNLE1BQU0scUJBQXFCLEdBQUcsQ0FBQyxLQUFhLEVBQWUsRUFBRTtJQUNsRSxJQUFJLElBQUEscUJBQWEsRUFBQyxLQUFLLENBQUMsRUFBRTtRQUN4QixPQUFPLEtBQUssQ0FBQTtLQUNiO0lBRUQsTUFBTSxLQUFLLENBQUMsSUFBSSxLQUFLLCtCQUErQixDQUFDLENBQUE7QUFDdkQsQ0FBQyxDQUFBO0FBTlksUUFBQSxxQkFBcUIseUJBTWpDIn0=